import React from "react";
export const COLUMNS = [
  {
    Header: "First Name",
    accessor: "first_name",
  },
  {
    Header: "Last Name",
    accessor: "last_name",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Approval Key",
    accessor: "key",
  },
  {
    Header: "Status",
    accessor: "approved_request",
    Cell: ({ cell }) =>
    cell.row.values.approved_request ? (
      <p>Approved</p>
    ) : <p>Not approved</p>,
  },
];
